module.exports = "/_next/static/images/b408a9a3c44778f2e330d437b5c9213d-lock-new.svg.webp";